// React
import React from "react";
import useResponsiveState from "../../../../hooks/useResponsiveState";

// Internal Components
import {
  ValuesIcon,
  DobIcon,
  MemoryIcon,
  VisionIcon,
  IkigaiIcon,
  QuoteIconV2,
  VitIcon,
  PreviousDay,
} from "../../../../components/ui/Icons/Icon";
import { continuationCalculator } from "../../../../utils/UtilityFunctions";
import YearTile from "./YearTile";

// The layout configuration is defined here.
// The string 'row-start / column-start / row-end / column-end' is for the `grid-area` property.
const desktopLayout = {
  name: "1 / 1 / 2 / 2",
  birthday: "2 / 1 / 3 / 2",
  values: "3 / 1 / 5 / 5",
  vision: "1 / 2 / 3 / 7",
  ikigai: "1 / 7 / 2 / 9",
  continuation: "2 / 7 / 3 / 9",
  quote: "3 / 5 / 5 / 7",
  memory: "3 / 7 / 5 / 9",
};

const tabletLayout = {
  name:         "1 / 1 / 2 / 2",
  birthday:     "2 / 1 / 3 / 2",
  continuation: "3 / 1 / 4 / 2",
  memory:       "4 / 1 / 5 / 2",
  quote:        "5 / 1 / 7 / 2",
  ikigai:       "7 / 1 / 9 / 2",
  values:       "1 / 2 / 5 / 4",
  vision:       "5 / 2 / 9 / 4",
};

function YearMap({ year, handleChange }) {
  const mapState = [
    { tile_name: "name", icon: <VitIcon /> },
    { tile_name: "birthday", icon: <DobIcon /> },
    { tile_name: "values", icon: <ValuesIcon /> },
    { tile_name: "vision", icon: <VisionIcon /> },
    { tile_name: "ikigai", icon: <IkigaiIcon /> },
    { tile_name: "continuation", icon: <PreviousDay /> },
    { tile_name: "quote", icon: <QuoteIconV2 /> },
    { tile_name: "memory", icon: <MemoryIcon /> },
  ];

  const { viewType } = useResponsiveState();
  const layout =
    viewType === "desktop"
      ? desktopLayout
      : viewType === "tablet"
      ? tabletLayout
      : null;

  const cont = year && continuationCalculator(year["birthday"]);

  return (
    <div id="yeartest">
      {mapState?.map((tile, index) => (
        <YearTile
          key={index}
          tile_name={tile.tile_name}
          value={
            tile.tile_name === "continuation" ? cont : year[tile.tile_name]
          }
          handleChange={handleChange}
          // Pass the grid-area string as a prop for CSS positioning.
          gridArea={layout ? layout[tile.tile_name] : null}
        >
          {tile.icon}
        </YearTile>
      ))}
    </div>
  );
}

export default YearMap;
